import http from "../api";
import { getBaseUrl, number } from "@iso/lib/helpers/utility";

import { getProducts } from '@iso/containers/PDV/scripts/storeProducts';
import { getLocalClients } from '@iso/containers/PDV/scripts/storeClients';
import { getConfig, saveConfig } from '@iso/containers/PDV/scripts/storeConfigs';
import { OrderStatus, saveLocalOrder, setSincronizedOrderById, getPendingOrders } from '@iso/containers/PDV/scripts/storeOrders';

import apiBoard from './board';
import apiPeople from './people';
import apiNotaFiscal from './notafiscal';
import apiIntegration from './integration';
import apiAccount from './accountCustumer';

let OrdersEndpoint = `${getBaseUrl()}/orders`;
let ClientsEndpoint = `${getBaseUrl()}/people`;

class PDVDataService {

    // Products

    async getProducts(isOnline) {
        if(isOnline)
            return apiBoard.getBoardData('0', 'productsAndServices');
        else
            return {'data': await getProducts()};
    }

    // Configs

    async getPDVConfigs(isOnline) {
        if(isOnline)
            return apiAccount.getPDVData();
        else
            return {'data': await getConfig('pdv_config')};
    }

    // Orders

    async setSincronizedOrder(local_id, data) {
        setSincronizedOrderById(local_id, data);
    }

    async sincPendingOrders() {
        try {
            let pending = await getPendingOrders();

            for await (const item of pending) {
                try {
                    await this.saveOrder(item).then(res=> {
                        if (res.data === 'ok')
                            this.setSincronizedOrder(item.local_id, { ...item, status: OrderStatus.Sincronized });
                    });
                } catch (error) {
                    console.log('saveOrder error: ', error)
                }
            }
            
        } catch (error) {
            console.log(error)
        }
    }

    async saveOrder(data) {

        saveLocalOrder(data);

        return http({
            'url': OrdersEndpoint,
            'method':'POST',
            'data': data
        });
    }

    async cancelOrder(data) {
        return http({
            'url': `${OrdersEndpoint}/cancel`,
            'method':'POST',
            'data': data
        });
    }

    // Clients

    async getClients(isOnline) {
        if(isOnline)
            return apiPeople.getSmallAll();
        else
            return {'data': await getLocalClients()};
    }

    // Pagamento

    async listingPaymentPIX(data) {
        try {
            console.log('data: ', data);

            let d = new Date();
            let dateNow = `${d.getFullYear()}-${number(d.getMonth() + 1)}-${number(d.getDate())}`

            console.log(dateNow)

            // dateNow = '2024-08-30'; // 2024-08-14
            let query = `payments?billingType=PIX&paymentDate=${dateNow}`

            if(data.reference !== undefined && data.reference != '')
                query += `&pixQrCodeId=${data.reference}`;

            console.log('query: ', query)

            return apiIntegration.getEspecialQuery(query)
        } catch (error) {
            console.log(error)
        }
    }

    async createNFCeFromOrder(lastSaleId, data) {
        try {
            return await apiNotaFiscal.createNotaFiscalBySale(lastSaleId, 'nfce', data);
        } catch (error) {
            console.log(error)
        }
    }
}

export default new PDVDataService();